import Vue from "vue";
import Router from "vue-router";
import Head from "vue-head";

import Component_home from "@/components/home";
import Component_portfolio from "@/components/portfolio";
import Component_portfolioView from "@/components/portfolioView";
import Component_about from "@/components/about";
import Component_contact from "@/components/contact";
import Component_review from "@/components/review";
import Component_policyService from "@/components/policyService";
import Component_policyPersonal from "@/components/policyPersonal";

Vue.use(Router);
Vue.use(Head);

export default new Router({
	mode : "history",
	routes : [
		{
			path : "*",
			redirect : "/"
		},
		{
			path : "/",
			name : "home",
			component : Component_home
		},
		{
			path : "/portfolio",
			name : "portfolio",
			component : Component_portfolio,
			children : [
				{
					path : ":no",
					name : "portfolioView",
					component : Component_portfolioView
				}
			]
		},
		{
			path : "/about",
			name : "about",
			component : Component_about
		},
		{
			path : "/contact",
			name : "contact",
			component : Component_contact
		},
		{
			path : "/review",
			name : "review",
			component : Component_review
		},
		{
			path : "/policy/service",
			name : "policyService",
			component : Component_policyService
		},
		{
			path : "/policy/personal",
			name : "policyPersonal",
			component : Component_policyPersonal
		}
	]
});


// WEBPACK FOOTER //
// ./src/router/index.js